export default "assets/images/icons/download-support-dc1e49b3.svg";